<template>
    <div class="component-buy-orders-pop-up">
        <vs-popup title="Conheça Mais"
            :active.sync="isActive"
            @close="$emit('isActiveFalse')"
            style="border-radius: 10px !important;"
        >
            <buy-orders @isActiveFalse="$emit('isActiveFalse')"></buy-orders>
        </vs-popup>
    </div>
</template>

<script>
    import BuyOrders from '../../orders/infos/Index'

    export default {
        name: 'BuyOrdersPopUp',
        components: {
          BuyOrders
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            }
        }
    }
</script>
